import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./fr.json";
import en from "./en.json";
import it from "./it.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      it: { translation: it },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en", "it"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

// Keep <html lang> in sync with the active language for a11y & SEO consistency.
const syncHtmlLang = (lng: string) => {
  if (typeof document === "undefined") return;
  const code = lng?.startsWith("fr") ? "fr" : lng?.startsWith("it") ? "it" : "en";
  document.documentElement.lang = code;
};
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
